import {FeatureCollection} from "geojson";

export const getEmptyData = (): {type: 'geojson', data: FeatureCollection} => ({
    "type": 'geojson',
    "data":{
        "type": "FeatureCollection",
        // "crs": { "type": "name", "properties": {} },
        "features": []
    }
});
